// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #1f2937;
  border: 1px solid #334155;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  width: 180px;
  min-height: 78px;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
}

/* Título o texto superior */
.dropdown-item-text {
  color: #f1f5f9;
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 10px;
  border-bottom: 1px solid #334155;
  padding-bottom: 8px;
}

/* Botones dentro del dropdown */
.dropdown-item {
  cursor: pointer;
  background-color: transparent;
  color: #e2e8f0;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease, color 0.2s ease;
  text-align: left;
  border-radius: 8px;
}

.dropdown-item:hover {
  background-color: rgba(59, 130, 246, 0.08); /* Azul translúcido */
  color: #69a9e9;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/DropdownMenu/DropdownMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uDAAuD;EACvD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C,EAAE,qBAAqB;EACjE,cAAc;AAChB","sourcesContent":[".dropdown-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #1f2937;\n  border: 1px solid #334155;\n  border-radius: 10px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n  width: 180px;\n  min-height: 78px;\n  display: flex;\n  flex-direction: column;\n  padding: 10px 0;\n}\n\n/* Título o texto superior */\n.dropdown-item-text {\n  color: #f1f5f9;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: center;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #334155;\n  padding-bottom: 8px;\n}\n\n/* Botones dentro del dropdown */\n.dropdown-item {\n  cursor: pointer;\n  background-color: transparent;\n  color: #e2e8f0;\n  border: none;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  text-align: left;\n  border-radius: 8px;\n}\n\n.dropdown-item:hover {\n  background-color: rgba(59, 130, 246, 0.08); /* Azul translúcido */\n  color: #69a9e9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
